import {
  ADD_CURRENCY_PAIR,
  ADD_CURRENCY_PAIR_SUCCESS,
  ADD_CURRENCY_PAIR_FAILURE,
  UPDATE_CURRENCY_PAIR,
  UPDATE_CURRENCY_PAIR_SUCCESS,
  UPDATE_CURRENCY_PAIR_FAILURE,
  FETCH_CURRENCY_PAIRS,
  FETCH_CURRENCY_PAIRS_SUCCESS,
  FETCH_CURRENCY_PAIRS_FAILURE,
  DELETE_CURRENCY_PAIR,
  DELETE_CURRENCY_PAIR_SUCCESS,
  DELETE_CURRENCY_PAIR_FAILURE,
} from "../actionTypes";

// Add Currency Pair
export const addCurrencyPair = (payload) => ({
  type: ADD_CURRENCY_PAIR,
  payload,
});

export const addCurrencyPairSuccess = (payload) => ({
  type: ADD_CURRENCY_PAIR_SUCCESS,
  payload,
});

export const addCurrencyPairFailure = (error) => ({
  type: ADD_CURRENCY_PAIR_FAILURE,
  payload: error,
});

// Update Currency Pair
export const updateCurrencyPair = (payload) => ({
  type: UPDATE_CURRENCY_PAIR,
  payload,
});

export const updateCurrencyPairSuccess = (payload) => ({
  type: UPDATE_CURRENCY_PAIR_SUCCESS,
  payload,
});

export const updateCurrencyPairFailure = (error) => ({
  type: UPDATE_CURRENCY_PAIR_FAILURE,
  payload: error,
});

// Fetch Currency Pairs
export const fetchCurrencyPairs = (payload) => ({
  type: FETCH_CURRENCY_PAIRS,
  payload,
});

export const fetchCurrencyPairsSuccess = (payload) => ({
  type: FETCH_CURRENCY_PAIRS_SUCCESS,
  payload,
});

export const fetchCurrencyPairsFailure = (error) => ({
  type: FETCH_CURRENCY_PAIRS_FAILURE,
  payload: error,
});

// Delete Currency Pair
export const deleteCurrencyPair = (payload) => ({
  type: DELETE_CURRENCY_PAIR,
  payload,
});

export const deleteCurrencyPairSuccess = (payload) => ({
  type: DELETE_CURRENCY_PAIR_SUCCESS,
  payload,
});

export const deleteCurrencyPairFailure = (error) => ({
  type: DELETE_CURRENCY_PAIR_FAILURE,
  payload: error,
});